import {
  CREATING_NDA_TEMPLATE_REQUEST,
  CREATING_NDA_TEMPLATE_SUCCEDDED,
  CREATING_NDA_TEMPLATE_FAILED,
  UPDATING_NDA_TEMPLATE_REQUEST,
  UPDATING_NDA_TEMPLATE_SUCCEDDED,
  UPDATING_NDA_TEMPLATE_FAILED,
  FETCHING_NDA_TEMPLATE_REQUEST,
  FETCHING_NDA_TEMPLATE_SUCCEDDED,
  FETCHING_NDA_TEMPLATE_FAILED,
  FETCHING_ALL_NDA_TEMPLATE_REQUEST,
  FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED,
  FETCHING_ALL_NDA_TEMPLATE_FAILED,
  DELETING_NDA_TEMPLATE_REQUEST,
  DELETING_NDA_TEMPLATE_SUCCEDDED,
  DELETING_NDA_TEMPLATE_FAILED,
} from "../actions/actionTypes.jsx";

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  creating: false,
  created: null,
  updating: false,
  error: null,
};

function ndaTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case CREATING_NDA_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        creating: true,
        created: null,
      });

    case CREATING_NDA_TEMPLATE_SUCCEDDED:
      var items = state.items.slice();
      items.splice(0, 0, action.payload);

      return Object.assign({}, state, {
        ...state,
        creating: false,
        created: action.payload,
        items: items,
      });

    case CREATING_NDA_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        ...state,
        creating: false,
        created: null,
        error: action.payload,
      });

    case UPDATING_NDA_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        updating: true,
      });

    case UPDATING_NDA_TEMPLATE_SUCCEDDED:
      var items = [action.payload, ...state.items];

      var items = state.items.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }

        return item;
      });

      return Object.assign({}, state, {
        ...state,
        updating: false,
        items: items,
      });

    case UPDATING_NDA_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        ...state,
        updating: false,
        error: action.payload.error,
      });

    case FETCHING_NDA_TEMPLATE_REQUEST:
      var id = action.payload;

      return Object.assign({}, state, {
        ...state,
        loading: true,
      });

    case FETCHING_NDA_TEMPLATE_SUCCEDDED:
      var id = action.payload.id;

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: action.payload,
      });

    case FETCHING_NDA_TEMPLATE_FAILED:
      var id = action.payload.id;

      return Object.assign({}, state, {
        ...state,
        loading: false,
        error: action.payload,
      });

    case FETCHING_ALL_NDA_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true,
      });

    case FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED:
      var items = action.payload;

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: items,
      });

    case FETCHING_ALL_NDA_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        error: action.payload,
      });

    case DELETING_NDA_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        deleting: true,
      });

    case DELETING_NDA_TEMPLATE_SUCCEDDED:
      var items = state.items.filter((item, index) => {
        return item.id != action.payload.id;
      });

      return Object.assign({}, state, {
        ...state,
        deleting: false,
        items: items,
      });

    case DELETING_NDA_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        ...state,
        deleting: false,
        error: action.payload,
      });

    default:
      return state;
  }
}

export { ndaTemplateReducer };
